<div class="search-box">
    <div class="col-auto p-0">
        <button class="btn-bd-empty" (click)='addTutorial()'>{{ 'CONFIGURE.ADD_NEW' | translate }}</button>
    </div>
    <div class="col-auto p-0 mt-4">
        <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
    </div>
</div>

<div *ngFor="let tutorialDetail of tutorialDetails | search:searchText:['title','description'] ;let i = index ">
    <div class="sop-box card-task">
        <div class="row">
            <div class="col-auto">
                <div class="sop-media"  (click)="openModal(template,tutorialDetail.fileURL,tutorialDetail.type,tutorialDetail.title)" >
                    <img *ngIf="tutorialDetail.type=='pdf'" src='assets/ph-bhp-configuration/svg/img2.jpg'>
                    <img *ngIf="tutorialDetail.type=='video'" src='assets/ph-bhp-configuration/svg/img1.jpg'>
                    <img *ngIf="tutorialDetail.type=='video'" class="video-icon" src='assets/ph-bhp-configuration/svg/icon-play-video.svg'>
                </div>
            </div>
            <div class="col p-2 pl-4">
                <h5 class="mt-2 card-task-title">{{tutorialDetail.title}}</h5>
                <p class="mb-0 card-task-desc">{{tutorialDetail.description}}</p>
            </div>
            <div class="col-auto width-auto p-2 pr-3 mr-2 d-flex align-items-center">
              <button class="action-button" (click)='emitTutorialData("edit",tutorialDetail.tutorialID)'>
                <img class="svg" src="assets/ph-bhp-layout/svg/icon-edit.svg">
              </button>
              <button class="action-button" (click)='openDeleteModal(this.delmodal,tutorialDetail.tutorialID)'>
                <img class="svg" src="assets/ph-bhp-layout/svg/icon-delete.svg">
              </button>
            </div>
        </div>
    </div>
</div>
<div class="alert alert-warning" role="alert" *ngIf="tutorialDetails && ((tutorialDetails | search:searchText:['title','description'] ).length == 0)">{{ translationKeys.Dashboard.NoDataFound | translate }}</div>
<ng-template #delmodal>

    <div class="modal-header bhp-modal-header">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body bhp-modal-body">
        <p class="">
            {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }}
        </p>
    </div>
    <div class="modal-footer bhp-modal-footer">
        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
    </div>
    </ng-template>

    <ng-template #template>
        <div *ngIf="filetype=='video'" class="heightFull">
            <video *ngIf="filetype=='video'" width="100%" height="100%" [src]="fileurl | safe" controlsList="nodownload" autoplay controls></video>
        </div>
        <div *ngIf="filetype=='pdf'" class="heightFull">
            <div class="modal-header justify-content-between align-items-center">
                <h5 class="modal-title">{{filetitle}}</h5>
                <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img
                    src="assets/ph-bhp-layout/svg/remove.svg"></a>
            </div>
             <div class="modal-body">
                <embed *ngIf="filetype=='pdf'" [src]="fileurl | safe" width="100%" height="100%" type="application/pdf">
            </div>
            <!-- <div class="modal-footer">
                <div class="container-fluid">
                    <div class="row">
                            <div class="col my-3 justify-content-center align-items-center d-flex">
                                <button  (click)="modalRef.hide()" class="btn btn-cancel mr-4">{{ translationKeys.InstitutionManagement.Close | translate }}</button>
                            </div>
                    </div>
                </div>
            </div> -->
        </div>
    </ng-template>

